// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage, intlShape } from 'react-intl';
import TextType from './TextType/TextType';
import CheckboxType from './CheckboxType/CheckboxType';
import RadioButtonType from './RadioType/RadioType';
import RangeType from './RangeType/RangeType';

import { generateTags } from './utils';

import style from './Filter.scss';
import icons from '../../assets/styles/icons.scss';

import type { Color } from '../Checkbox/Checkbox';

type Props = {
  filterFields: FilterField[];
  handleDeleteTag: (name?: string, field?: string) => void;
  hasBorder?: boolean;
};

export type FilterField = FilterTextType | FilterCheckboxType | FilterRadioType | FilterRangeType;

export type FilterTextType = {
  icon?: string;
  placeholderIntl: string;
  stateValue?: {
    value: string;
  };
  type: 'text';
  titleIntl?: string;
  handler: (event: any) => void;
  name: string;
  isOpen: boolean;
  handleOpen: (name: string) => void;
};

export type FilterCheckbox = {
  label?: string;
  labelIntl?: string;
  value: string;
};

export type FilterCheckboxType = {
  stateValue?: {
    [key: string]: boolean;
  };
  checkboxes?: FilterCheckbox[];
  color?: Color;

  type: 'checkbox';
  titleIntl: string;
  handler: (event: any) => void;
  name: string;
  isOpen: boolean;
  handleOpen: (name: string) => void;
};

export type FilterRadioButton = {
  label?: string;
  labelIntl?: string;
  value: string;
};

export type FilterRadioType = {
  stateValue?: {
    value: string;
  };
  radioButtons?: FilterRadioButton[];
  type: 'radio';
  titleIntl: string;
  handler: (event: any) => void;
  name: string;
  isOpen: boolean;
  handleOpen: (name: string) => void;
};

export type FilterRangeType = {
  type: 'range';
  titleIntl: string;
  isOpen: boolean;
  name: string;
  stateValue?: {
    value: string;
  };
  minStateValue?: {
    value: string;
  };
  maxStateValue?: {
    value: string;
  };
  handleOpen: (name: string) => void;
  options: {
    min: number;
    max: number;
    defaultValue?: number[];
    onChange: () => void;
  };
};

export default class Filter extends Component<Props, void> {
  render() {
    const { filterFields, handleDeleteTag, hasBorder } = this.props;
    const content = filterFields.map((filterField: FilterField, n: number) => {
      const field = [];
      switch (filterField.type) {
        case 'text':
          field.push(<TextType key={`${filterField.type}-${n}`}
                               filterField={filterField}/>);
          break;
        case 'checkbox':
          field.push(<CheckboxType key={`${filterField.type}-${n}`}
                                   filterField={filterField}/>);
          break;
        case 'radio':
          field.push(<RadioButtonType key={`${filterField.type}-${n}`}
                                      filterField={filterField}/>);
          break;
        case 'range':
          field.push(<RangeType key={`${filterField.type}-${n}`}
                                filterField={filterField}/>);
      }
      if (n !== filterFields.length - 1) {
        field.push(<hr className={style.hr}
                       key={n}/>);
      }
      return field;
    });
    // const tags: any = generateTags(filterFields, handleDeleteTag, this.context.intl.formatMessage);
    return (
      <section className={classNames(style.filterWrap, { [style.border]: hasBorder })}>
        {/*<article>
          <FormattedMessage id="filter.title">{
            txt => <h3 className={style.title}><i className={icons.symbolTweak}/>{txt}</h3>
          }</FormattedMessage>
        </article>
        <ul className={style.tags}>
          {tags}
        </ul>*/}
        <article className={style.content}>{content}</article>
      </section>
    );
  }
}

Filter.propTypes = {
  filterFields: PropTypes.array.isRequired,
  handleDeleteTag: PropTypes.func.isRequired,
  hasBorder: PropTypes.bool,
};

Filter.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/Filter/Filter.jsx